import { Component, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnChanges {

	private static readonly DEFAULT_WIDTH: string = '85%';

	@Input() public trackEventPrefix: string = '';

	/* Hide modal by default */
	@Input() public isVisible: boolean = false;
	@Output() public isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	/* Optional height and width (defaults to %, suffix number by px to make it in pixels). Default = fullscreen */
	@Input() public height: string | number;
	@Input() public width: string | number;
	@Input() public enableBackdrop: boolean = false; // optional grey backdrop
	@Input() public enableClose: boolean = true;
	/* CSS style object that configures overrides to modal height. */
	public overrideStyles: Object;

	public ngOnChanges(): void {
		this.overrideStyles = {}; // reset overrides to start afresh
		if (this.isVisible) {
			if (this.width !== undefined) {
				this.overrideStyles['width'] = this.width;
			}
			if (this.height !== undefined) {
				this.overrideStyles['height'] = this.height;
			}
		}
	}

	public onCloseButtonClick(): void {
		if (this.enableClose && this.isVisible) {
			this.isVisible = false;
			this.isVisibleChange.emit(this.isVisible);
		}
	}

	@HostListener('document:keydown', ['$event'])
	public onEscapeKeyPress(event): void {
		const escapeKey = 27;
		const isKeyEscapePressed = event.keyCode === escapeKey;
		if (this.enableClose && isKeyEscapePressed) {
			this.onCloseButtonClick();
		}
	}
}
